import React from "react";

const Footer = () => {

  let copyYear = new Date();
  copyYear = copyYear.getFullYear();

  const classFooter = "container-fluid bg-primary text-light d-flex justify-content-center align-items-center py-4 shadow",
    classCopyright = "text-uppercase font-weight-light text-center text-muted";

  return (
    <footer className={classFooter}>
      <small className={classCopyright}>Copyright &copy; {copyYear}. Advanced Copy Center, Inc. </small> 
    </footer>  
  );
}

export default Footer;